<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox">
          <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
          </el-input>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" style="width: 100%">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>

            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="lockTime" label="审稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.expertTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="step" label="状态">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.status == 3">已退稿</el-tag>
                <el-tag type="warning" v-if="scope.row.status == 4">拟录用</el-tag>
                <el-tag type="success" v-if="scope.row.status == 5">已录用</el-tag>
                <el-tag type="primary" v-else-if="scope.row.status == 1">{{ getStatusText(scope.row.step) }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="center" width="110">
              <template slot-scope="scope">
                <el-button size="small" @click="showProcess(scope.row.id)">查看流程</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="EXPERT"></ArticleProcess>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import expertApi from "@/api/expert"

export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "已评审稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      drawer: false,
      drawerTitle: "",
      curArticleId: 0,
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    getStatusText(step) {
      for (let i = 0; i < this.$config.steps.length; i++) {
        if (step == this.$config.steps[i].step) {
          return this.$config.steps[i].title
        }
      }
      return ""
    },
    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    loadData() {
      expertApi.articleListAudited(this.f_subjectId, this.f_title, "", "", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    openDraw(title) {
      this.drawer = true
      this.drawerTitle = title
    },

    showProcess(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    /* openDrawer(articleId) {
      this.curArticleId = articleId;
      this.drawer = true;
      //this.loadProcessData(articleId)
    },

    closeDrawer() {
      this.drawer = false
    },

    rejectSuccess(){
      this.closeDrawer();
      this.loadData();
    } */
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

/deep/.el-drawer__body {
  display: flex;
}
/* 
.searchItem label{
    width:100px;
    float:left;
    text-align: center;
}
.searchItem>div{
    margin-left: 120px;
}
.vTag{
    line-height: 30px;
    border:1px solid #ccc;
    border-radius: 3px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    padding: 0 15px;
    font-size: 14px;
    cursor: pointer;
    
}
.vTag.actvie{
    background-color: #409eff;
    color:#FFF;
}
*/
</style>
